module.exports = __webpack_public_path__ + "img/72_14.5bea0866.png";